import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import useQueryString from '../../../hooks/use-query-string';
import retakeBanner from '../../../assets/retake-banner.jpg';
import './retakes.scss';
import { Student, StudentImage, Djob, School } from '../../../models';
import routes from '../../../routes';

function useStudentImages(schoolId, studentId) {
  return useQuery(['STUDENT_IMAGES', schoolId, studentId], () => (
    Student
      .where({ schoolId, studentId, is_enrolled: true })
      .first()
      .then(async (studentRes) => (
        StudentImage
          .where({ studentId: studentRes.data.id, forCurrentSeason: true })
          .first()
          .then((studentImageRes) => studentImageRes.data)
      ))
  ));
}

function useDjobs(schoolId) {
  return useQuery(['DJOBS', schoolId], () => (
    Djob
      .where({ closest_retake_date_for_school: schoolId })
      .first()
      .then(djobRes => djobRes.data)
  ));
}

function useSchool(schoolId) {
  return useQuery(['SCHOOL', schoolId], () => (
    School
      .find(schoolId)
      .then(schoolRes => schoolRes.data)
  ));
}

export default function Retakes() {
  const history = useHistory();
  const { sch: schoolId, sid: studentId, season: season, access_code: accessCode } = useQueryString();
  const { isLoading, data: studentImage } = useStudentImages(schoolId, studentId);
  const { data: djob } = useDjobs(schoolId);
  const { data: school } = useSchool(schoolId);

  const [hasError, setHasError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    studentImage.needsRetake = true;

    const res = await studentImage.save();

    if (res) history.push(routes.retakes.confirmation({ sch: schoolId, sid: studentId, season: season, access_code: accessCode }));
    else setHasError(true);
  };

  return (
    <div className="retakes-page">
      {hasError && (
        <p className="retake-error-msg">
          Sorry something went wrong signing up for a retake, please try again at a later date.
        </p>
      )}
      <img alt="Retake Banner" className="banner-img" src={retakeBanner} />
      <div className="info">
        <p>Your school pictures matter!</p>
        <p>Lets make it right.</p>
        <p className="sign-up-text">Sign Up for Retake Day</p>
      </div>

      {studentImage && (
        <form onSubmit={handleSubmit}>
          <button disabled={isLoading} className="submit-btn" type="submit">Click Here</button>
        </form>
      )}

      <div className="retake-info">
        <p style={{ marginBottom: '1rem' }}>{school && school.name}</p>
        <p>Retake Picture Day is</p>

        {djob && djob.date && (
          <>
            <p>{djob.date}</p>
            <p>Retake request must be submitted 48 hours (2 days) before Retake Day.</p>
          </>
        )}
      </div>

      <div className="link-container">
        <a href={`/c/sittings?sid=${studentId}&school=${schoolId}&access_code=${accessCode}&season=${season}&from=retakes`} className="submit-btn">
          View current images
        </a>
      </div>
    </div>
  );
}
